import { render, staticRenderFns } from "./Advert.vue?vue&type=template&id=bfbcfaf0&scoped=true&"
import script from "./Advert.vue?vue&type=script&lang=ts&"
export * from "./Advert.vue?vue&type=script&lang=ts&"
import style0 from "./Advert.vue?vue&type=style&index=0&id=bfbcfaf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbcfaf0",
  null
  
)

export default component.exports